import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  title: string;
};

export const CommonSection: FC<Props> = ({ children, title }) => (
  <div className="search-filter">
    <div className="search_facet__title">
      <FormattedMessage id={title} />
    </div>
    <div className="search_facet__wrapper">{children}</div>
  </div>
);
